import Vue from "vue";
import { ElementTiptapPlugin } from "element-tiptap";
import "element-ui/lib/theme-chalk/index.css";
import "element-tiptap/lib/index.css";

Vue.use(ElementTiptapPlugin, {
  lang: "es",
});
